import { GetDoc } from "@/Utils/StateLib";

type Props = {
  rowState: {
    colIndex: number;
    rowIndex: number;
    hovered: boolean;
    data: Record<string, string>;
  };
};

export const AlternateTopboxRow = (props: Props) => {
  const doc = GetDoc();
  const objDB = doc?.GetObjDB();
  const boxClass = objDB?.GetClassByName("Box");
  const personIdDef = boxClass?.GetFieldDefByID("PersonID");
  const nameDef = boxClass?.GetFieldDefByID("Name");
  if (!personIdDef || !nameDef) {
    return null;
  }

  const personIDField = personIdDef.GetFieldName();
  const nameField = nameDef.GetFieldName();

  const personId = props.rowState.data[personIDField];
  const name = props.rowState.data[nameField];

  return <div data-testid={`alt-topbox-record-${name}`}>{`${name} (${personId})`}</div>;
};
